module.exports = __webpack_public_path__ + "static/media/bgcTitle.a8fb9f13.png";